import { isNil } from 'lodash';
import { RoutesList } from 'routes';

interface NotificationQueryParams {
    encode: (params: { selectedChannel: Nullable<string | number> }) => string;
}

interface RouteItem {
    path: string;
    name: string;
}

interface NotificationSaveResultArgs {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    eventId: Nullable<number>;
    selectedNotificationChannel: Nullable<string | number>;
    queryParams: NotificationQueryParams;
    goToRoute: (route: RouteItem, routeParams?: AnyObject, queryString?: string, isReplace?: boolean) => void;
}

// Reused by template wrappers to keep event redirect behavior consistent.
export const createNotificationSaveResult = ({
    data,
    eventId,
    selectedNotificationChannel,
    queryParams,
    goToRoute,
}: NotificationSaveResultArgs) => {
    if (isNil(eventId)) {
        return data;
    }

    return {
        ...(data ?? {}),
        customRoute: () => {
            goToRoute(
                RoutesList.NOTIFICATION,
                { eventId },
                queryParams.encode({ selectedChannel: selectedNotificationChannel }),
            );
        },
    };
};
